export default "__VITE_ASSET__lWogpjXQ__"